export interface AppType {
  _id: string;
  type: string;
  name: string;
  description?: string;
  subtype?: { value: string; name: string; description?: string; _id?: string }[];
  config?: Record<string, unknown>;
}

export const apptypes: AppType[] = [];
